import { Link, NavLink } from "react-router-dom";
import { List, X, Phone } from "@phosphor-icons/react";
import { useState } from "react";
import { LOGO_URL } from "@/data/content";
import { PHONE_DISPLAY, PHONE_TEL } from "@/components/PhoneCTA";

export default function Navbar({ dark = false }) {
  const [open, setOpen] = useState(false);
  const txt = dark ? "text-[#F7F5F0]" : "text-[#1C1C1C]";
  const txtMuted = dark ? "text-[#A09E9A]" : "text-[#666460]";
  const border = dark ? "border-white/10" : "border-[#E0DDD6]";
  const bg = dark ? "bg-transparent" : "bg-[#F7F5F0]/90 backdrop-blur-md";

  const links = [
    { to: "/", label: "Discover" },
    { to: "/destinations", label: "Destinations" },
    { to: "/journal", label: "Journal" },
    { to: "/contact", label: "Contact" },
    { to: "/admin/login", label: "Admin" },
  ];

  return (
    <header className={`absolute top-0 left-0 right-0 z-50 border-b ${border} ${bg}`} data-testid="navbar">
      <div className="px-6 md:px-12 lg:px-24 py-4 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group" aria-label="TheCityPair home">
          <img
            src={LOGO_URL}
            alt="TheCityPair"
            data-testid="logo-img"
            className="h-12 md:h-14 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide font-medium transition-colors ${
                  isActive ? "text-[#C29B62]" : `${txtMuted} hover:text-[#C29B62]`
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="nav-call-btn"
            className="flex items-center gap-2 px-4 py-2 bg-[#C29B62] text-[#0A0A0B] text-xs tracking-[0.16em] uppercase font-semibold hover:bg-[#A88550] transition-colors"
          >
            <Phone size={14} weight="fill" /> {PHONE_DISPLAY}
          </a>
        </nav>

        <button
          onClick={() => setOpen(!open)}
          className={`md:hidden ${txt} -mr-2 p-2 flex items-center justify-center min-h-[44px] min-w-[44px]`}
          data-testid="nav-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className={`md:hidden ${dark ? "bg-[#0A0A0B]" : "bg-white"} border-t ${border}`}>
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mnav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`text-sm ${txtMuted} hover:text-[#C29B62]`}
              >
                {l.label}
              </Link>
            ))}
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="mnav-call-btn"
              className="flex items-center gap-2 px-4 py-2 bg-[#C29B62] text-[#0A0A0B] text-xs tracking-[0.16em] uppercase font-semibold w-fit"
            >
              <Phone size={14} weight="fill" /> Call {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
